import React from "react";
// NAVIGATION
import { useLocation } from "react-router-dom";
import useLeaveStandaloneEditor from "../../../customHooks/useLeaveStandaloneEditor";
// WIZARD
import { WizardProvider } from "../../setupWizard/WizardContext";
import StepBanks from "../../setupWizard/steps/StepBanks";

function BanksEdit() {
  const leave = useLeaveStandaloneEditor("/edge-management/banks");
  const location = useLocation();
  const idBank = new URLSearchParams(location.search).get("idBank");

  return (
    <WizardProvider>
      <StepBanks
        editBankId={idBank || undefined}
        standalone
        onSaveSuccess={leave}
        onCancel={leave}
      />
    </WizardProvider>
  );
}

export default BanksEdit;
